import style from './style.module.scss';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useProductLabels} from 'modules/product-snippet/components/ProductSnippetContainer/hooks/useProductLabels';
import {Labels} from 'components/ProductSnippet/components/Labels';
import {ProductSnippetAnalyticsProvider} from 'modules/analytics/providers/ProductSnippetAnalyticsProvider';
import {useAnalytics} from 'modules/product-snippet/components/ProductSnippetContainer/hooks/useAnalytics';
import {useProductAvailability} from 'modules/product-snippet/components/ProductSnippetContainer/hooks/useProductAvailability';
import {useProductPrice} from 'modules/product-snippet/components/ProductSnippetContainer/hooks/useProductPrice';
import {useProductFineAndRare} from 'modules/product-snippet/components/ProductSnippetContainer/hooks/useProductFineAndRare';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {IProductSnippet} from 'shared/types/productSnippet.types';

interface IProductHeaderLabelsContentProps {
    productData: IProduct;
    labels: IProductSnippet['labels'];
    isFineAndRare: boolean;
    price: IProductSnippet['price'];
}

const ProductHeaderLabelsContent = ({productData, labels, isFineAndRare, price}: IProductHeaderLabelsContentProps) => {
    const {onStockClick} = useAnalytics({
        isFineAndRare,
        price,
        product: productData,
    });

    return (
        <div className={style.root}>
            <Labels id={productData.id} labels={labels} onStockClick={onStockClick} />
        </div>
    );
};

export const ProductHeaderLabels = () => {
    const productData = useAppSelector(selectProductData);

    const labels = useProductLabels(productData?.labels);
    const isPrive = useIsPrive();
    const availability = useProductAvailability(productData!, isPrive);
    const price = useProductPrice({product: productData!, availability});
    const isFineAndRare = useProductFineAndRare(productData?.properties);

    if (0 >= labels.length || !productData?.id) {
        return null;
    }

    return (
        <ProductSnippetAnalyticsProvider>
            <ProductHeaderLabelsContent
                productData={productData}
                labels={labels}
                isFineAndRare={isFineAndRare}
                price={price}
            />
        </ProductSnippetAnalyticsProvider>
    );
};
